import { Api, IConfig } from 'elc-service';
import { POWER_REVIEWS_API_LINK } from '../internal/constants/PowerReviews';
import { ConfigStore } from '../service-setup/ConfigStore';

export interface IReviewSnippetApiSdkConfig extends IConfig {
    configStore: ConfigStore;
}

export interface IReviewSnippetResultData {
    data: {
        results: IReviewSnippetApiResult[];
    };
}

export interface IReviewSnippetApiResult {
    page_id: string;
    rollup: IRollup;
}

interface IRollup {
    average_rating: number;
    review_count: number;
    answered_questions: number;
}

export class ReviewSnippetApiSdk extends Api {
    private config: IReviewSnippetApiSdkConfig;

    constructor(config: IReviewSnippetApiSdkConfig, serviceName: string, serviceVersion: string) {
        super(config, serviceName, serviceVersion);
        this.config = config;
    }

    public async getReviewSnippet(pageIds: string[]): Promise<IReviewSnippetApiResult[]> {
        try {
            const {
                merchantId,
                locale,
                apiKey,
            } = this.config.configStore.config.ratingsReviewsConfig;
            const joinedPageIds = pageIds.join(',');

            const url = `${POWER_REVIEWS_API_LINK}/m/${merchantId}/l/${locale}/product/${joinedPageIds}/snippet?apikey=${apiKey}`;
            const response: IReviewSnippetResultData = await this.httpTransport.get({ url });

            return response.data.results;
        } catch (err) {
            throw err;
        }
    }
}
